<template>
  <div class="main-bolsa mb-4">
    <b-jumbotron class="title_page">
      <h1 class="text-center font-weight-bold">Google Callback</h1>
    </b-jumbotron>
    <bread-cpv class="adjustment-breadcrumb"></bread-cpv>

    <b-container fluid="xl"> Google Callback </b-container>
  </div>
</template>

<script>
import BreadCpv from "@/components/global/bread-cpv.vue";
export default {
  name: "GoogleCallback",
  components: { BreadCpv },
  data() {
    return {
      //
    };
  },
  created: function () {
    //
  },
  beforeDestroy: function () {
    //
  },
  methods: {
    //
  },
};
</script>

<style lang="scss" scoped>
//
</style>
